exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir] .policies-info-container{margin-top:35px}[dir=ltr] .policies-info-container,[dir=rtl] .policies-info-container{padding-left:30px;padding-right:30px}@media (max-width:991px){[dir] .policies-info-container{margin-top:20px}[dir=ltr] .policies-info-container,[dir=rtl] .policies-info-container{padding-left:15px;padding-right:15px}}[dir] .rate-name{margin-bottom:10px}@media (max-width:991px){[dir] .rate-name{margin-bottom:20px}}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/policies/policies.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/policies/policies.component.scss
// module chunks = 0